<template>
  <transition name="van-fade" mode="out-in">
     <router-view/>
  </transition>
</template>

<style lang="scss">
</style>
